// 统一 API 基址与请求封装。
//
// Dev:  默认相对路径 '/api/v1' + CRA dev proxy（package.json 中 "proxy" 指向后端 8000），
//        浏览器视角同源，无需 CORS。
// Prod: 前端与后端同一域名（nginx 将 /api 反代到后端），或设置 REACT_APP_API_URL 环境变量。
export const API_V1 = process.env.REACT_APP_API_URL || '/api/v1';

export async function apiGet(url) {
  const res = await fetch(url, { headers: { Accept: 'application/json' } });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const body = await res.json();
      detail = body.detail || detail;
    } catch {
      // 响应体不是 JSON（如 Starlette 默认 HTML 错误页），保留状态码信息
    }
    throw new Error(detail);
  }
  return res.json();
}
